var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUrbanFashion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 640,
    viewBox: "0 0 360 640",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#667eea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#764ba2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 640,
    fill: "url(#g1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 440,
    width: 60,
    height: 160,
    fill: "rgba(255,255,255,0.2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 400,
    width: 45,
    height: 200,
    fill: "rgba(255,255,255,0.15)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 420,
    width: 75,
    height: 180,
    fill: "rgba(255,255,255,0.18)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 460,
    width: 40,
    height: 140,
    fill: "rgba(255,255,255,0.22)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 200,
    r: 80,
    fill: "rgba(255,255,255,0.1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrbanFashion);
export default __webpack_public_path__ + "static/media/urban-fashion.1f47b186e2c2f0359f2efac36eb70256.svg";
export { ForwardRef as ReactComponent };